import { render, staticRenderFns } from "./dashboardFasi.vue?vue&type=template&id=5092424e&scoped=true&"
import script from "./dashboardFasi.vue?vue&type=script&lang=js&"
export * from "./dashboardFasi.vue?vue&type=script&lang=js&"
import style0 from "./dashboardFasi.vue?vue&type=style&index=0&id=5092424e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5092424e",
  null
  
)

export default component.exports